// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"partials_wrapper__3lCTC","backButton":"partials_backButton__yJMsk","title":"partials_title__2TRUY","paneContent":"partials_paneContent__23l6S"};